import { getNowTimestamp } from '@shared/helpers/date';

import { RoundResult } from '../RoundResult';
import type { AdjacentRound } from './adjacentRound';

export enum PredictionRoundState {
  ACTIVE = 'ACTIVE',
  LOCKED = 'LOCKED',
  CLOSED = 'CLOSED',
}

type GetPredictionRoundByStateProps = {
  rounds?: AdjacentRound[];
  state: PredictionRoundState;
};

export const getPredictionRoundByState = ({
  rounds,
  state,
}: GetPredictionRoundByStateProps): AdjacentRound | undefined => {
  return rounds?.find((round) => round.state === state);
};

export const isPredictionRoundEnded = (round: AdjacentRound): boolean => {
  return round.closeTimestamp < getNowTimestamp();
};

export const getPredictionRoundTimeRemaining = (round: AdjacentRound): number => {
  return Math.max(round.closeTimestamp - getNowTimestamp(), 0);
};

export const getPredictionRoundResult = (round: AdjacentRound): RoundResult => {
  if (round.priceChange.wei > 0) {
    return RoundResult.UP;
  }

  if (round.priceChange.wei < 0) {
    return RoundResult.DOWN;
  }

  return RoundResult.DRAW;
};
